module.exports = __webpack_public_path__ + "img/2019-styria.bc0e206f.jpg";